import React from "react";
import CrewCartMember from "./CrewCartMember.jsx";
import { useTranslation } from 'react-i18next';

const CrewCartItemOverView = ({crewCart, currencyFormatter, className="crew-cart-checkout"}) => {
    const { t } = useTranslation();
    return (
        <React.Fragment>
            <style>
                {`
                    .overview-container {
                    max-height:35vh;
                    overflow-y:scroll;
                        width: 100%;
                    }

                    .overview-header {
                        display: grid;
                        grid-template-columns: 2fr 1fr 1fr 1fr;
                        padding: 10px;
                        font-weight: bold;
                        margin-bottom: 10px;
                    }

                    .overview-header > span:first-child {
                        text-align: left;
                    }

                    .overview-header > span:nth-child(2) {
                        text-align: center;
                    }

                    .overview-header > span:nth-child(3),
                    .overview-header > span:nth-child(4) {
                        text-align: right;
                    }

                    .overview-row {
                        display: grid;
                        grid-template-columns: 2fr 1fr 1fr 1fr;
                        align-items: center;
                        padding: 10px;
                    }

                    .overview-row > span:first-child {
                        text-align: left;
                    }

                    .overview-row > span:nth-child(2) {
                        text-align: center;
                    }

                    .overview-row > span:nth-child(3),
                    .overview-row > span:nth-child(4) {
                        text-align: right;
                    }

                    .member-info {
                        display: flex;
                        align-items: center;
                        gap: 10px;
                    }
                `}
            </style>

                <div className={className}>
                    <div className="overview-container">
                        <div className="overview-header">
                            <span>{t('overview.name')} ({crewCart?.members?.length})</span>
                            <span>{t('overview.totalItems')}</span>
                            <span>{t('overview.price')}</span>
                            <span>{t('overview.total')}</span>
                        </div>
                        <div>
                            {crewCart?.members?.map((member, index) => {
                                const memberItems = crewCart?.items?.filter(
                                    (item) => item.crew_cart_member_id === member.id
                                ) || [];
                                const totalItems = memberItems.reduce((acc, item) => acc + item.quantity, 0);
                                const totalPrice = memberItems
                                    .reduce((acc, item) => acc + parseFloat(item.price), 0)
                                    .toFixed(2);

                                const discountedPrice = memberItems
                                    .reduce((acc, item) => acc + (item.discounted_price ? parseFloat(item.discounted_price) : 0), 0)
                                    .toFixed(2);
                                return (
                                    <div key={member.id} className="overview-row">
                                        <span>
                                            <div className="member-info">
                                                <CrewCartMember
                                                    name={member?.name}
                                                    status={member?.status}
                                                    size={35}
                                                />
                                                <span>{member?.name}</span>
                                            </div>
                                        </span>
                                        <span>{totalItems} items</span>
                                        <span>
                                            {discountedPrice > 0 ?
                                                <strike>{currencyFormatter?.format(totalPrice) ?? totalPrice}</strike> :
                                                currencyFormatter?.format(totalPrice) ?? totalPrice}
                                        </span>
                                        <span>
                                            {discountedPrice > 0 ?
                                                currencyFormatter?.format(discountedPrice) ?? discountedPrice :
                                                currencyFormatter?.format(totalPrice) ?? totalPrice}
                                        </span>
                                    </div>
                                )
                            })}
                        </div>
                    </div>
                </div>
        </React.Fragment>
    );
}

export default CrewCartItemOverView;
